export const FormCount = () => {
  const deleteButton = document.querySelectorAll('.js-form-delete');
  if (deleteButton.length > 1) {
    deleteButton.forEach((button) => {
      button.classList.add('js-form-delete--open');
    });
  } else {
    deleteButton.forEach((button) => {
      if(!button.classList.contains("js-form-nocount"))
        button.classList.remove('js-form-delete--open');
    });
  }
};

FormCount();
